import { Link } from 'react-router-dom';
import { Receipt } from 'lucide-react';
import { Button } from '@/shared/ui/button';
import { cn } from '@/shared/lib/utils';
import { usePreviousOrders } from '../hooks/usePreviousOrders';

interface Props {
  restaurantId: string;
}

/**
 * Navbar entry point to the "My orders" page. Only rendered once the visitor
 * has at least one saved order on this device.
 */
export function PreviousOrdersButton({ restaurantId }: Props) {
  const orders = usePreviousOrders(restaurantId);
  if (orders.length === 0) return null;

  return (
    <Button
      variant="ghost"
      size="sm"
      className={cn(
        'relative min-h-[44px] min-w-[44px] h-9 w-9 sm:h-9 sm:w-9 rounded-xl shrink-0 hover:bg-muted',
      )}
      asChild
    >
      <Link to={`/${restaurantId}/orders`} aria-label={`My orders (${orders.length})`}>
        <Receipt className="w-4 h-4" />
        <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-accent text-accent-foreground text-[10px] flex items-center justify-center font-bold">
          {orders.length > 9 ? '9+' : orders.length}
        </span>
      </Link>
    </Button>
  );
}
